import { ObjectAnyType } from '@/types/generic'

import {
    AccountEntity,
    CampaignEntity,
    UserEntity,
    ExtensionEntity,
    QueueEntity,
    DidEntity,
    VoiceBotEntity,
    UserRecord,
    DefaultAccountBreak,
    Category
} from '@/types/entities'

export interface EntityConfig<T> {
    idKey: keyof T
    labelKey: keyof T
    accountIdKey?: keyof T
    icon?: string
}

export type EntityKey = keyof typeof ENTITIES_CONFIG

export type EntityData =
    | AccountEntity
    | UserEntity
    | ExtensionEntity
    | QueueEntity
    | CampaignEntity
    | DidEntity
    | VoiceBotEntity
    | UserRecord
    | DefaultAccountBreak
    | Category
    | ObjectAnyType

export interface EntitiesConfigMap {
    /* ===================== CORE ===================== */

    Accounts: EntityConfig<AccountEntity>
    Users: EntityConfig<UserEntity>
    Extension: EntityConfig<ExtensionEntity>
    Queues: EntityConfig<QueueEntity>
    Campaigns: EntityConfig<CampaignEntity>
    DIDs: EntityConfig<DidEntity>
    VoiceBotList: EntityConfig<VoiceBotEntity>

    /* ===================== RECORDS ===================== */

    UserRecords: EntityConfig<UserRecord>
    DefaultAccountBreak: EntityConfig<DefaultAccountBreak>

    /* ===================== CAMPAIGNS / FLOWS ===================== */

    AutomaticCampaigns: EntityConfig<ObjectAnyType>
    IVRCampaigns: EntityConfig<ObjectAnyType>
    Layers: EntityConfig<ObjectAnyType>

    /* ===================== AI ===================== */

    AiCategories: EntityConfig<Category>
}


export const ENTITIES_CONFIG: EntitiesConfigMap = {
    /* ===================== CORE ENTITIES ===================== */

    Accounts: {
        idKey: 'AccountID',
        labelKey: 'dist_name',
        accountIdKey: 'AccountID',
        icon: 'Building',
    },

    Users: {
        idKey: 'user_id',
        labelKey: 'user_name',
        accountIdKey: 'AccountID',
        icon: 'User',
    },

    Extension: {
        idKey: 'extension_id',
        labelKey: 'ext_name',
        accountIdKey: 'AccountID',
        icon: 'Contact',
    },

    Queues: {
        idKey: 'queue_id',
        labelKey: 'q_name',
        accountIdKey: 'AccountID',
        icon: 'Users',
    },

    Campaigns: {
        idKey: 'camp_id',
        labelKey: 'camp_name',
        accountIdKey: 'AccountID',
        icon: 'Megaphone',
    },

    DIDs: {
        idKey: 'user_did_id',
        labelKey: 'did_name',
        accountIdKey: 'AccountID',
        icon: 'Phone',
    },

    VoiceBotList: {
        idKey: 'BotID',
        labelKey: 'Name',
        accountIdKey: 'AccountID',
        icon: 'Bot',
    },

    /* ===================== RECORDS & SYSTEM ===================== */

    UserRecords: {
        idKey: 'RecordID',
        labelKey: 'Description',
        icon: 'FileAudio',
    },

    DefaultAccountBreak: {
        idKey: 'StatusID',
        labelKey: 'Name',
        icon: 'PauseCircle',
    },

    AiCategories: {
        idKey: 'CategoryID',
        labelKey: 'CategoryName',
        icon: 'Brain',
    },

    /* ===================== CAMPAIGN / FLOW ENTITIES ===================== */

    AutomaticCampaigns: {
        idKey: 'CampaignID',
        labelKey: 'Name',
        accountIdKey: 'AccountID',
        icon: 'Zap',
    },

    IVRCampaigns: {
        idKey: 'CampaignID',
        labelKey: 'Name',
        accountIdKey: 'AccountID',
        icon: 'PhoneCall',
    },

    Layers: {
        idKey: 'layer_id',
        labelKey: 'layer_name',
        accountIdKey: 'AccountID',
        icon: 'Layers',
    },
}

